import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useMemo } from 'react';
import { Scopes } from '../../utils/constants';
import { hasScope } from '../../utils/auth';
import { jsx as _jsx } from "react/jsx-runtime";
export function CreateSubscriptionTooltip({
  'data-test-id': dataTestId = 'create-subscription-tooltip',
  renderChild
}) {
  const hasSubscriptionWrite = hasScope(Scopes.subscription.write);
  const tooltipProps = useMemo(() => {
    if (!hasSubscriptionWrite) {
      return {
        disabled: false,
        title: /*#__PURE__*/_jsx("span", {
          "data-test-id": "create-subscription-tooltip-message:missing-permissions",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.CreateSubscriptionButton.tooltip.insufficientAccess"
          })
        })
      };
    }
    return {
      disabled: true
    };
  }, [hasSubscriptionWrite]);
  const childProps = useMemo(() => ({
    loading: false,
    disabled: !tooltipProps.disabled
  }), [tooltipProps]);
  return /*#__PURE__*/_jsx(Tooltip, Object.assign({
    "data-test-id": dataTestId
  }, tooltipProps, {
    children: renderChild(childProps)
  }));
}